import codeSVG from '@plone/volto/icons/code.svg';
import DiagramView from './components/View';
import DiagramEdit from './components/Edit';
import MermaidDiagram from './components/MermaidDiagram';

// Named exports for consumers that compose (the KB viewer imports
// MermaidDiagram; see DR-2026-271 §KB corpus surface).
export { MermaidDiagram, DiagramView, DiagramEdit };

const applyConfig = (config) => {
  config.blocks.blocksConfig.diagram = {
    id: 'diagram',
    title: 'Diagram',
    icon: codeSVG,
    group: 'text',
    view: DiagramView,
    edit: DiagramEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    // The textarea owns its keyboard; without this, Volto's block-engine
    // key handling (Enter=new block, Backspace=delete block) fires inside it.
    blockHasOwnFocusManagement: true,
  };
  return config;
};

export default applyConfig;
